<template>
	<v-dialog :value="show" @input="$emit('close')" max-width="600px" persistent>
		<VmDialogCard
			:title="announcement.title"
			:buttonTitle="announcement.isRead ? '' : '既読にする'"
			cancelButtonTitle="閉じる"
			:disabled="announcement.isRead"
			@click="markAsReadAndClose"
			@close="$emit('close')"
		>
			<template v-slot:cardContent>
				<div class="announcement-detail-content">
					<div class="content-header">
						<div class="meta-info">
							<div class="meta-row">
								<span class="meta-label">作成日時:</span>
								<span class="meta-value">{{ formatDate(announcement.createdAt) }}</span>
							</div>
							<div class="meta-row" v-if="!announcement.isRead">
								<span class="meta-label">ステータス:</span>
								<v-chip small color="primary" text-color="white" class="status-chip"> 未読 </v-chip>
							</div>
						</div>
					</div>

					<v-divider class="content-divider" />

					<div class="announcement-content">
						<div class="content-text" v-html="formatContent(announcement.content)"></div>
					</div>
				</div>
			</template>
		</VmDialogCard>
	</v-dialog>
</template>

<script>
import VmDialogCard from '../Molecules/VmDialogCard'

export default {
	name: 'AnnouncementDetailDialog',
	components: {
		VmDialogCard
	},
	props: {
		announcement: {
			type: Object,
			required: true
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		markAsReadAndClose() {
			this.$emit('mark-as-read', this.announcement.id)
			this.$emit('close')
		},
		formatDate(dateString) {
			const date = new Date(dateString)
			return date.toLocaleDateString('ja-JP', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
			})
		},
		formatContent(content) {
			// 改行文字をHTMLの改行に変換
			return content.replace(/\n/g, '<br>')
		}
	}
}
</script>

<style lang="scss" scoped>
.announcement-detail-content {
	.content-header {
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;

		.meta-info {
			flex: 1;

			.meta-row {
				display: flex;
				align-items: center;
				margin-bottom: 8px;

				&:last-child {
					margin-bottom: 0;
				}

				.meta-label {
					font-weight: 600;
					color: #333;
					margin-right: 8px;
					min-width: 80px;
				}

				.meta-value {
					color: #666;
					font-size: 0.9rem;
				}

				.status-chip {
					margin-left: 4px;
				}
			}
		}
	}

	.content-divider {
		margin: 20px 0;
	}

	.announcement-content {
		.content-text {
			line-height: 1.8;
			color: #333;
			font-size: 1rem;

			::v-deep br {
				margin-bottom: 8px;
			}
		}
	}
}

@media (max-width: 600px) {
	.announcement-detail-content {
		.content-header {
			flex-direction: column;
			gap: 12px;

			.meta-info {
				.meta-row {
					flex-direction: column;
					align-items: flex-start;
					gap: 6px;

					.meta-label {
						min-width: auto;
						margin-right: 0;
					}
				}
			}
		}

		.announcement-content {
			.content-text {
				font-size: 0.95rem;
			}
		}
	}
}
</style>
